<div class="relatedto-main-container input">

  <div class="free-text-container">

    <input type="text" class="free-text" [disabled]="disabled" [value]="airportSearchText"
      placeholder="Type airport code or name (e.g. DEL, Delhi)"
      (input)="airportSearchText = $any($event.target).value; onAirportSearchTextChange()" (blur)="hideResults()">

  </div>
  <div class="search-results-main-container" *ngIf="airportSearchResults.length">
    <ul class="search-list">
      <li class="list-item" *ngFor="let airport of airportSearchResults" (mousedown)="selectAirport(airport)">
        {{ airport.code }}
        -
        {{ airport.name }},
        {{ airport.cityName }}
        ({{ airport.countryName }})
      </li>
    </ul>
  </div>
</div>